import {round} from "lodash"

export const prettyDigit = (digit) => {
	return new Intl.NumberFormat('ru-RU').format(round(digit, 2))
}
